import React, { useEffect, useCallback } from 'react';
import { withError } from '../../../shared/components/error-boundary';

import useAddToCart from '../../../hooks/useAddToCart';
import { useCartActions } from '../../../hooks/useCartState';

/*
 * This component is used to add the missing hardware to the cart
 */
export default withError(({ item, missingHW, refreshCarePackInfo }) => {
    const { confirmAddToCart } = useAddToCart();
    const { updateCartItem } = useCartActions();
    const onHWChange = useCallback(
        (product, quantity, blockFlyout, addOns, addToCartOptions, baseProductSku, xsellType, metricParams) => {
            const { baseSKU, userInputBaseSKU } = addToCartOptions || {};
            const serialNumber = userInputBaseSKU || (baseSKU ? `SKU=${baseSKU}` : undefined);
            if (product && serialNumber) {
                const { orderItemId } = item || {};
                return updateCartItem(orderItemId, undefined, {
                    comment: serialNumber,
                    check: undefined,
                    cql: 40,
                    cal: 12000,
                }).then(r => {
                    //if mapped to a hardware sku in cart, refresh the carepack info
                    if (baseSKU) {
                        return refreshCarePackInfo();
                    }
                    return r;
                });
            } else {
                //if modal closed without hardware info, remove the item from the cart
                updateCartItem(item.orderItemId, 0);
                return Promise.resolve();
            }
        },
        [item],
    );
    useEffect(() => {
        if (missingHW && confirmAddToCart) {
            confirmAddToCart('ecarepack', [item], onHWChange);
        }
    }, [missingHW]);
});
